import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Divider, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import OrganizationService from "../api/organization";
import { useDispatch, useSelector } from "react-redux";
import TemplateTable from "../common/Layout/templatePages/templateTable";
import { setOrganizations } from "../store/organziationsSlice";

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.custom.backgroundColor,
    borderRadius: "3px",
    padding: "8px 16px",
    color: theme.palette.custom.text,
    height: "36px",
    minHeight: "36px",
    "&.Mui-selected": {
      color: theme.palette.custom.text,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
      color: theme.palette.primary,
    },
    "&:hover": {
      backgroundColor: theme.palette.custom.buttonColor,
      color: theme.palette.custom.buttonHoverTextColor,
      opacity: "70%",
    },
  })
);
function OrganizationsModules() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const organziations = useSelector(({ organziations }) => organziations);
  const [loadingValue, setLoadingValue] = useState(false);
  const [modules, setModules] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [disabledTab, setDisabledTab] = useState(true);

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("user"));
    const organizationsArray = userObj.organizations;
    dispatch(
      setOrganizations({ jsonCurrent: organizationsArray, newSearchText: "" })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getModules(row) {
    OrganizationService.GetOperationFeatures(row.id)
      .then((jsonCurrent) => {
        if (jsonCurrent?.operation_profile_feature_link?.length) {
          setModules(jsonCurrent?.operation_profile_feature_link);
        }
        setLoadingValue(false);
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setDisabledTab(true);
  };
  const handleButton = (event, buttonType, row) => {
    if (buttonType === "view") {
      setLoadingValue(true);
      setTabValue(1);
      setDisabledTab(false);
      getModules(row);
    }
  };
  return (
    <Box
      sx={{
        p: "12px",
        backgroundColor: theme.palette.custom.backgroundColor,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: { xs: "block", sm: "center" },
          gap: "1rem",
        }}
      >
        <Typography
          sx={{ fontSize: "45px", mb: 0, color: theme.palette.custom.text }}
          variant="h2"
          gutterBottom
        >
          {t("OrganizationsModules")}
        </Typography>
      </Box>
      <Divider
        sx={{ mb: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Tabs
        sx={{ mt: "2rem" }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{
          style: { backgroundColor: theme.palette.custom.borderColor },
        }}
        value={tabValue}
        onChange={handleTabChange}
        textColor="secondary"
      >
        <StyledTab label={t("Organizations")} />
        <StyledTab label={t("Modules")} disabled={disabledTab} />
      </Tabs>
      {tabValue === 0 && (
        <TemplateTable
          headCells={[
            {
              id: "icon",
              label: " ",
              icon: "iconPublicURL",
            },
            { id: "name" },
            { id: "emailAddress" },
            { id: "mobileNumber" },
            { id: `website` },
            {
              id: `action`,
              buttons: ["view"],
            },
          ]}
          itemsList={organziations}
          itemId="id"
          searchAttributes={["name", "emailAddress", "mobileNumber", "website"]}
          handleButton={handleButton}
        />
      )}
      {tabValue === 1 && (
        <TemplateTable
          headCells={[
            {
              id: "feature.name",
              label: "Name",
            },
            {
              id: "feature.display_order",
              label: "Order",
            },
            {
              id: "feature.status",
              label: "Status",
            },
            // {
            //     id: `action`,
            //     buttons: [""]
            // },
          ]}
          itemsList={modules}
          itemId="feature.feature_uid"
          loading={loadingValue}
          searchAttributes={["feature.name", "feature.description"]}
          // allowExport
          // exportTitle={`${modules[0]?.operation_profile?.full_name} Modules`}
        />
      )}
    </Box>
  );
}

export default OrganizationsModules;
